import { render, staticRenderFns } from "./EmailMessage.vue?vue&type=template&id=f8c7873a&scoped=true"
import script from "./EmailMessage.vue?vue&type=script&lang=js"
export * from "./EmailMessage.vue?vue&type=script&lang=js"
import style0 from "./EmailMessage.vue?vue&type=style&index=0&id=f8c7873a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c7873a",
  null
  
)

export default component.exports